import { render } from "./LangIcon.vue?vue&type=template&id=e5356372&scoped=true"
import script from "./LangIcon.vue?vue&type=script&lang=js"
export * from "./LangIcon.vue?vue&type=script&lang=js"

import "./LangIcon.vue?vue&type=style&index=0&id=e5356372&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5356372"],['__file',"src/components/ChatWidget/ChatIcons/LangIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5356372"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5356372', __exports__)) {
    api.reload('e5356372', __exports__)
  }
  
  module.hot.accept("./LangIcon.vue?vue&type=template&id=e5356372&scoped=true", () => {
    api.rerender('e5356372', render)
  })

}


export default __exports__